import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { useAuth, isAdmin, isStaff } from '../auth';
import { AppLayout } from '../layouts/AppLayout';
import { Login } from '../pages/Login';
import { Dashboard } from '../pages/Dashboard';
import { CfdiCatalogo } from '../pages/CfdiCatalogo';
import { ReportesList } from '../pages/reportes/ReportesList';
import { ReporteDetalle } from '../pages/reportes/ReporteDetalle';
import { MatchManual } from '../pages/reportes/MatchManual';
import { ManualSelect } from '../pages/reportes/ManualSelect';
import { MisConciliaciones } from '../pages/MisConciliaciones';
import { CargaArchivos } from '../pages/CargaArchivos';
import { EstadoSat } from '../pages/EstadoSat';
import { GestionUsuarios } from '../pages/admin/GestionUsuarios';
import { Registro } from '../pages/Registro';
import { ProtectedRoute } from './ProtectedRoute';
import { RoleRoute } from './RoleRoute';

// Fuerza remount al cambiar de RFC por navegación client-side (sin esto, los
// hooks de usePersistedState quedan leyendo la clave de la empresa anterior).
function MatchManualByRfc() {
  const { rfc } = useParams<{ rfc: string }>();
  return <MatchManual key={rfc} />;
}

function Home() {
  const { user } = useAuth();
  if (isAdmin(user))  return <Navigate to="/dashboard" replace />;
  if (isStaff(user))  return <Navigate to="/reportes" replace />;
  return <Navigate to="/mis-conciliaciones" replace />;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<Home />} />

          {/* Staff (Admin + Contador) */}
          <Route element={<RoleRoute allow={['AdminGlobal', 'Contador']} />}>
            <Route path="reportes"                 element={<ReportesList />} />
            <Route path="reportes/:rfc/match"      element={<MatchManualByRfc />} />
            <Route path="match"                    element={<ManualSelect />} />
            <Route path="estado-sat"               element={<EstadoSat />} />
            <Route path="cfdi-catalogo"            element={<CfdiCatalogo />} />
          </Route>

          {/* Detalle: visible para todos los autenticados */}
          <Route path="reportes/:rfc"              element={<ReporteDetalle />} />

          {/* Cliente */}
          <Route path="mis-conciliaciones"         element={<MisConciliaciones />} />

          {/* Admin */}
          <Route element={<RoleRoute allow={['AdminGlobal']} />}>
            <Route path="carga"                    element={<CargaArchivos />} />
          </Route>

          {/* Dashboard solo Admin (puede crecer) */}
          <Route element={<RoleRoute allow={['AdminGlobal']} />}>
            <Route path="dashboard"                element={<Dashboard />} />
          </Route>

          {/* Admin: Gestión de Usuarios */}
          <Route element={<RoleRoute allow={['AdminGlobal']} />}>
            <Route path="usuarios"                 element={<GestionUsuarios />} />
          </Route>
        </Route>
      </Route>

      {/* Registro público (sin autenticación) */}
      <Route path="registro" element={<Registro />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
